import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=55ff1fc3&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=55ff1fc3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports